export function getInitials(name: string | null | undefined): string {
    const trimmed = name?.trim();
    if (!trimmed) {
        return "K";
    }
    return trimmed
        .split(/\s+/)
        .slice(0, 2)
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
}
